module.exports = __webpack_public_path__ + "img/loopi-banner.e10e2bdc.png";